import { render } from "./BirthYearPage.vue?vue&type=template&id=5a3a33a8&scoped=true"
import script from "./BirthYearPage.vue?vue&type=script&lang=js"
export * from "./BirthYearPage.vue?vue&type=script&lang=js"

import "./BirthYearPage.vue?vue&type=style&index=0&id=5a3a33a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3a33a8"]])

export default __exports__